import { useState, useEffect } from 'react';

export function useTypewriter(words: string[], typingSpeed = 150, deletingSpeed = 75, pauseDuration = 2000) {
  const [displayText, setDisplayText] = useState('');
  const [wordIndex, setWordIndex] = useState(0);
  const [isTyping, setIsTyping] = useState(true);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    let timeout: NodeJS.Timeout;

    if (isPaused) {
      timeout = setTimeout(() => {
        setIsPaused(false);
        setIsTyping(false);
      }, pauseDuration);
      return () => clearTimeout(timeout);
    }

    const currentWord = words[wordIndex];
    
    if (isTyping) {
      if (displayText === currentWord) {
        setIsPaused(true);
        return;
      }

      timeout = setTimeout(() => {
        setDisplayText(currentWord.slice(0, displayText.length + 1));
      }, typingSpeed);
    } else {
      if (displayText === '') {
        setWordIndex((prev) => (prev + 1) % words.length);
        setIsTyping(true);
        return;
      }

      timeout = setTimeout(() => {
        setDisplayText(displayText.slice(0, -1));
      }, deletingSpeed);
    }

    return () => clearTimeout(timeout);
  }, [displayText, wordIndex, isTyping, isPaused, words, typingSpeed, deletingSpeed, pauseDuration]);

  return displayText;
}